import { render, staticRenderFns } from "./DrawerLink.vue?vue&type=template&id=608ce07b&scoped=true&"
import script from "./DrawerLink.vue?vue&type=script&lang=js&"
export * from "./DrawerLink.vue?vue&type=script&lang=js&"
import style0 from "./DrawerLink.vue?vue&type=style&index=0&id=608ce07b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ce07b",
  null
  
)

export default component.exports